import { createInitialStates, createResourceNames, createSequenceTypes, getErrorData } from '../helpers'
import { INITIAL_STATE_REDUCERS } from '../constants'

const RESOURCES = ['contractSendUrlPost', 'eDocSingProviderEContractCreatePost', 'eDocSingProviderEContractGet']
const R = createResourceNames(RESOURCES)
const TYPES = createSequenceTypes([
  'CONTRACT_SEND_URL_POST',
  'EDOCSIGNPROVIDER_ECONTRACT_CREATE_POST',
  'EDOCSIGNPROVIDER_ECONTRACT_GET'
])
export const INITIAL_STATE = {
  ...createInitialStates(RESOURCES, INITIAL_STATE_REDUCERS)
}

const reducers = {
  // CONTRACT SEND URL POST ····················································
  [TYPES.CONTRACT_SEND_URL_POST_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.contractSendUrlPost]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.CONTRACT_SEND_URL_POST_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [payload.data]
    return {
      ...state,
      [R.contractSendUrlPost]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.CONTRACT_SEND_URL_POST_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.contractSendUrlPost]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.CONTRACT_SEND_URL_POST_RESET]: (state: any) => {
    const RESOURCE_NAME = R.contractSendUrlPost
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // E-CONTRACT CREATE POST ····················································
  [TYPES.EDOCSIGNPROVIDER_ECONTRACT_CREATE_POST_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.eDocSingProviderEContractCreatePost]: {
        data: [],
        error: {},
        isLoading: true
      }
    }
  },
  [TYPES.EDOCSIGNPROVIDER_ECONTRACT_CREATE_POST_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [payload.data]
    return {
      ...state,
      [R.eDocSingProviderEContractCreatePost]: {
        error: {},
        data,
        isLoading: false
      }
    }
  },
  [TYPES.EDOCSIGNPROVIDER_ECONTRACT_CREATE_POST_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.eDocSingProviderEContractCreatePost]: {
        data: [],
        error,
        isLoading: false
      }
    }
  },
  [TYPES.EDOCSIGNPROVIDER_ECONTRACT_CREATE_POST_RESET]: (state: any) => {
    const RESOURCE_NAME = R.eDocSingProviderEContractCreatePost
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // E-CONTRACT GET ····························································
  [TYPES.EDOCSIGNPROVIDER_ECONTRACT_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.eDocSingProviderEContractGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.EDOCSIGNPROVIDER_ECONTRACT_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [payload.data]
    return {
      ...state,
      [R.eDocSingProviderEContractGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.EDOCSIGNPROVIDER_ECONTRACT_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.eDocSingProviderEContractGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.EDOCSIGNPROVIDER_ECONTRACT_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.eDocSingProviderEContractGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  }
}

export default reducers
